"use strict";

var _excluded = ["sku", "confirmation"],
    _excluded2 = ["onCompleted"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _unique = function _unique(definitions) {
  var names = {};
  return definitions.filter(function (definition) {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }

    var name = definition.name.value;

    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};

import { useCallback, useEffect } from 'react';
import { useFlixApiContext } from '../FlixApiContext';
import { CHECKOUT_INITIATED, SUBSCRIBED } from '../eventsNames';
import { useMutationWithValidation } from '../useMutationWithValidation';
import { authStatus } from '../user/AuthStatus/authStatus';
import { userProfileFragment } from '../user/UserProfile/useUserProfileQuery';
var START_SUBSCRIPTION = {
  "kind": "Document",
  "definitions": /*#__PURE__*/_unique( /*#__PURE__*/[{
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "StartSubscriptionInput"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "REST"
      }
    },
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "planSku"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "paymentMethodId"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "paymentIntentId"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "userId"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "receiptId"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "receipt"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "transactionId"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "subscriptionId"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }]
    }
  }, {
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "startSubscription"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "provider"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "operation"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "input"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "StartSubscriptionInput"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "startSubscription"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "provider"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "provider"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "operation"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "operation"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "input"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "input"
            }
          }
        }],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "rest"
          },
          "arguments": [{
            "kind": "Argument",
            "name": {
              "kind": "Name",
              "value": "type"
            },
            "value": {
              "kind": "StringValue",
              "value": "NewSubscription",
              "block": false
            }
          }, {
            "kind": "Argument",
            "name": {
              "kind": "Name",
              "value": "method"
            },
            "value": {
              "kind": "StringValue",
              "value": "POST",
              "block": false
            }
          }, {
            "kind": "Argument",
            "name": {
              "kind": "Name",
              "value": "endpoint"
            },
            "value": {
              "kind": "StringValue",
              "value": "v2",
              "block": false
            }
          }, {
            "kind": "Argument",
            "name": {
              "kind": "Name",
              "value": "path"
            },
            "value": {
              "kind": "StringValue",
              "value": "subscription/{args.operation}-{args.provider}",
              "block": false
            }
          }]
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "authStatus"
            },
            "arguments": [],
            "directives": [{
              "kind": "Directive",
              "name": {
                "kind": "Name",
                "value": "type"
              },
              "arguments": [{
                "kind": "Argument",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "value": {
                  "kind": "StringValue",
                  "value": "AuthStatus",
                  "block": false
                }
              }]
            }],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "AuthStatus"
                },
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "memberProfile"
            },
            "arguments": [],
            "directives": [{
              "kind": "Directive",
              "name": {
                "kind": "Name",
                "value": "type"
              },
              "arguments": [{
                "kind": "Argument",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "value": {
                  "kind": "StringValue",
                  "value": "UserProfile",
                  "block": false
                }
              }]
            }],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "FragmentSpread",
                "name": {
                  "kind": "Name",
                  "value": "UserProfileFragment"
                },
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "requiresAction"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "clientSecret"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }].concat(authStatus.definitions, userProfileFragment.definitions)),
  "loc": {
    "start": 0,
    "end": 1078,
    "source": {
      "body": "\n  fragment StartSubscriptionInput on REST {\n    # Card subscription\n    planSku: String\n    paymentMethodId: String\n    # Card subscription confirmation after handling Stripe required action\n    paymentIntentId: String\n    # Amazon subscription\n    userId: String\n    receiptId: String\n    # Apple subscription\n    receipt: String\n    # Roku subscription\n    transactionId: String\n    # PayPal subscription\n    subscriptionId: String\n  }\n\n  mutation startSubscription(\n    $provider: String!\n    $operation: String!\n    $input: StartSubscriptionInput!\n  ) {\n    startSubscription(provider: $provider, operation: $operation, input: $input)\n      @rest(\n        type: \"NewSubscription\"\n        method: \"POST\"\n        endpoint: \"v2\"\n        path: \"subscription/{args.operation}-{args.provider}\"\n      ) {\n      authStatus @type(name: \"AuthStatus\") {\n        ...AuthStatus\n      }\n      memberProfile @type(name: \"UserProfile\") {\n        ...UserProfileFragment\n      }\n      # Stripe card payments may require further action\n      requiresAction\n      clientSecret\n    }\n  }\n  \n  \n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var normalizeVars = function normalizeVars(provider, _ref) {
  var sku = _ref.sku,
      confirmation = _ref.confirmation,
      input = _objectWithoutProperties(_ref, _excluded);

  return {
    variables: {
      provider: provider,
      operation: confirmation ? 'confirm' : 'start',
      input: _objectSpread(_objectSpread({}, input), {}, {
        planSku: sku
      })
    }
  };
};

export var useStartSubscriptionMutation = function useStartSubscriptionMutation(plan) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var onCompleted = _ref2.onCompleted,
      options = _objectWithoutProperties(_ref2, _excluded2);

  var _useFlixApiContext = useFlixApiContext(),
      events = _useFlixApiContext.events;

  var emit = useCallback(function (event) {
    plan && events.emit(event, plan.sku, plan.currency, plan.price / 100, plan.hasFreeTrial);
  }, [events, plan]);
  useEffect(function () {
    emit(CHECKOUT_INITIATED);
  }, []); // eslint-disable-line

  var _useMutationWithValid = useMutationWithValidation(START_SUBSCRIPTION, _objectSpread(_objectSpread({}, options), {}, {
    onCompleted: useCallback(function (data) {
      if (!data.startSubscription.requiresAction) {
        emit(SUBSCRIBED);
        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(data);
      }
    }, [emit, onCompleted])
  })),
      _useMutationWithValid2 = _slicedToArray(_useMutationWithValid, 2),
      startSubscription = _useMutationWithValid2[0],
      status = _useMutationWithValid2[1];

  return [useCallback(function (provider, input) {
    return startSubscription(normalizeVars(provider, input));
  }, [startSubscription]), status];
};